export const universalHeaderId = 'universal-header'
